import classnames from "classnames";
import { noop } from "lodash";
import { t } from "@/i18n-js/instance";
import { useJoinSpace } from "@circle-react/components/Spaces/hooks";
import {
  useIsOrCanBeCommunityMember,
  usePunditUserContext,
} from "@circle-react/contexts";
import type { Space } from "@circle-react/types";
import { Button } from "@circle-react-uikit/Button";

export interface JoinSpaceButtonProps {
  setOpenNotificationsDropdown: () => void;
  space: Space;
}

export const JoinSpaceButton = ({
  space,
  setOpenNotificationsDropdown,
  ...passThroughProps
}: JoinSpaceButtonProps) => {
  const { isViewOnlyMasquerading } = usePunditUserContext();
  const isOrCanBeCommunityMember = useIsOrCanBeCommunityMember();
  const { isSubmitting, joinSpace } = useJoinSpace({
    space,
    setOpenNotificationsDropdown,
  });

  if (!isOrCanBeCommunityMember) {
    return null;
  }

  return (
    <div className="button_to">
      <Button
        variant="primary"
        {...passThroughProps}
        type="button"
        onClick={isViewOnlyMasquerading ? noop : joinSpace}
        data-testid="join-space"
        className={classnames({ "cursor-not-allowed": isViewOnlyMasquerading })}
        large
      >
        {t(isSubmitting ? "joining" : "join_space")}
      </Button>
    </div>
  );
};
